import React from 'react';
import { CodeExample } from '@cimpress/react-components';

import FourOhFourCode from '!raw-loader!./fourohfour.jsx';
import FourOhFourDemo from './fourohfour.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const FourOhFourDocs = () => {
  const message = {
    name: 'message',
    type: 'node',
    default:
      '"Oops! Something has gone wrong and the page you were looking for could not be displayed. Try the homepage."',
    description: 'Text to give a user suggestions for next steps when the get a 404 error.',
  };

  return (
    <ComponentDoc name="404" propInfos={[message]}>
      <FourOhFourDemo />
      <CodeExample code={FourOhFourCode} />
    </ComponentDoc>
  );
};

export default FourOhFourDocs;
